import { FC } from "react";
import { useNavigate } from "react-router-dom";

import { ReactComponent as KYCFailed } from "../../../assets/illustrations/kyc-fail-240x240.svg";
import { Button, Icon } from "../../../components/common";
import ServicesLayout from "../../../layouts/Services.layout";
import { ROUTES } from "../../../routes";

export const OnmetaKYCFailure: FC = () => {
  const navigate = useNavigate();

  return (
    <ServicesLayout
      image={<KYCFailed />}
      title="Your profile could not be verified"
    >
      <div className="flex flex-col items-stretch gap-6 md:gap-12">
        <div className="flex flex-col items-center gap-4">
          <Icon icon="Exclamation" size={64} className="text-orange-500" />

          <div className="font-poppins font-bold text-xl">
            Please contact our support team for further assistance
          </div>
        </div>

        <div className="flex flex-col justify-center gap-4 items-center mt-4">
          <Button
            className="contact-support-btn"
            variant={Button.variant.PRIMARY}
          >
            Get Help{" "}
            <Icon
              icon="support_agent"
              size={24}
              className="text-white"
              disableFill
            />
          </Button>

          <Button
            variant={Button.variant.TERTIARY}
            onClick={() => navigate(ROUTES.HOME)}
          >
            Try again
          </Button>
        </div>
      </div>
    </ServicesLayout>
  );
};
